<template>
	<div>
		<div>
			<span class="xbed-sub-title">房间物资出入库表</span>
		</div>

		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>房间物资出入库表</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
		<Form inline @submit.native.prevent="preventSubmit">
			<FormItem label="物资变化时间:" :label-width="110">
				<DatePicker type="month" placeholder="请选择" style="width: 150px" :clearable="false" v-model="query.month"></DatePicker>
			</FormItem>
			<FormItem label="房间id:" :label-width="84">
				<Input v-model="query.roomId" style="width: 150px"></Input>
			</FormItem>
			<FormItem label="房间名:" :label-width="84">
				<Input v-model="query.roomName"></Input>
			</FormItem>
			<FormItem label="物品名称:" :label-width="84">
				<Input v-model="query.goodsName"></Input>
			</FormItem>
			<FormItem label="物料编号:" :label-width="84">
				<Input v-model="query.stockNumber"></Input>
			</FormItem>
			<br>
			<FormItem label="关联城市:" :label-width="84">
				<Input v-model="query.associatedCityName"></Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="keyWordsTable">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportExcal" :loading="exportBtn">导出表格</Button>
			</FormItem>
		</Form>
		<Content>
			<Table class="expand-table" :columns="table.columns" :data="table.data" :loading="table.loading"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :current="query.page" :total="table.total" :page-size="query.size" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</Content>
	</div>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
import Config from "@/config";
import Moment from "moment";
import expandRow from "@/components/table-inventory";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	mounted() {
		this.roomGoodInventoryList();
		this.$Notice.config( {
			top: 200
		} )
	},
	components: {expandRow},
	data() {
		return {
			exportBtn: false,
			query: {
				page: 1,
				size: 10,
				month: Moment()
					.add( "month" )
					.format( "YYYY-MM" ),
				roomId: "",
				roomName: "",
				goodsName: '',
				stockNumber: '',
				associatedCityName: ''
			},
			queryParams: {
				page: 1,
				size: 10,
				month: Moment()
					.add( "month" )
					.format( "YYYY-MM" ),
				roomId: "",
				roomName: "",
				goodsName: '',
				stockNumber: '',
				associatedCityName: ''
			},
			table: {
				data: [],
				total: 0,
				loading: false,
				columns: [
					{
						title: "查看",
						type: 'expand',
						width: 70,
						align: "center",
						render: ( h, params ) => {
							return h( expandRow, {
								props: {
									row: params.row.List
								}
							} )
						}
					},
					{
						title: "操作",
						align: "center",
						width: 80,
						render: ( h, p ) => {
							return h(
								"Button",
								{
									props: {
										type: "primary",
										size: "small"
									},
									on: {
										click: () => {
											if ( !Utils.hasPermission( 'oms_xbclean_MmRoomGoodsInventoryParticular_list' ) ) {
												this.$Notice.error( {
													title: "无权限操作"
												} );
												return
											}
											if ( this.$router ) {
												window.open( `#/app/cleaner/inventoryDetails?roomId=${ p.row.roomId }` )
											} else {
												window.open( `#/Cleaner/Cleaner/inventoryDetails?roomId=${ p.row.roomId }` );
											}
										}
									}
								},
								"查看详情"
							);
						}
					},
					{
						title: "房间id",
						align: "center",
						width: 100,
						key: "roomId"
					},
					{
						title: "房间名称",
						align: "center",
						width: 120,
						key: "roomName"
					},
					{
						title: "城市",
						align: "center",
						width: 120,
						key: "associatedCityName"
					},
					{
						title: "物品id",
						align: "center",
						width: 100,
					},
					{
						title: "物品名称",
						align: "center",
						width: 120,
					},
					{
						title: "物料编号",
						align: "center",
						width: 130,
					},
					{
						title: "一级类别",
						align: "center",
						width: 115,
					},
					{
						title: "规格",
						align: "center",
						width: 100,
					},
					// {
					//   title: "期初单价",
					//   align: "center",
					//   width: 120,
					// },
					{
						title: "期初数量",
						align: "center",
						width: 100,
					},
					// {
					//   title: "期初金额",
					//   align: "center",
					//   width: 120,
					// },
					// {
					//   title: "入库单价",
					//   align: "center",
					//   width: 120,
					// },
					{
						title: "入库数量",
						align: "center",
						width: 100,
					},

					// {
					//   title: "入库金额",
					//   align: "center",
					//   width: 120,
					// },
					// {
					//   title: "出库单价",
					//   align: "center",
					//   width: 120,
					// },
					{
						title: "出库数量",
						align: "center",
						width: 100,
					},
					{
						title: "金额",
						align: "center",
						width: 100,
					},
					// {
					//   title: "期末单价",
					//   align: "center",
					//   width: 120,
					// },
					{
						title: "期末数量",
						align: "center",
						width: 100,
					},
					// {
					//   title: "期末金额",
					//   align: "center",
					//   width: 120,
					// }
				]
			}
		};
	},
	methods: {
		changePage( page ) {
			this.queryParams.page = page;
			this.roomGoodInventoryList()
		},
		changePageSize( pageSize ) {
			this.queryParams.page = 1;
			this.queryParams.size = pageSize;
			this.roomGoodInventoryList()
		},
		// 查询
		keyWordsTable() {
			this.queryParams = Object.assign( {}, this.query );
			this.roomGoodInventoryList();
		},
		// 加载所有的房间
		async roomGoodInventoryList() {
			this.queryParams.month = this.query.month
				? Moment( this.query.month ).format( "YYYY-MM" )
				: "";
			let resp = ( await API.omsAPI[this.env].cleaner.roomGoodInventoryList( this.queryParams, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return;
			}
			this.table.data = resp.content || [];
			this.table.total = resp.totalCount;
		},
		// 导出表格
		exportExcal() {
			if ( !Utils.hasPermission( 'excel_MmRoomGoodsInventoryParticular' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			let params = {
				roomId: this.queryParams.roomId,
				roomName: this.queryParams.roomName,
				month: this.queryParams.month,
				goodsName: this.queryParams.goodsName,
				stockNumber: this.queryParams.stockNumber,
				associatedCityName: this.queryParams.associatedCityName,
				page: 1,
				size: 99999,
			};
			const initParam = params => {
				let paramStr = "";
				Object.keys( params ).forEach( item => {
					if ( params[item] !== "" ) {
						paramStr += item + "=" + params[item] + "&";
					}
				} );
				return paramStr.substring( 0, paramStr.lastIndexOf( "&" ) );
			};
			let paramStr = initParam( params );
			let url = `${
				Config[this.env].analysisUrl
				}excel/MmMonthlyRoomGoodsInventories?${ paramStr }`;
			// window.open(url, "_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		},
		preventSubmit() {
			return false;
		}
	}
};
</script>
<style lang="scss" scoped>
td.ivu-table-expanded-cell {
	padding: 0 !important;
}
</style>





// WEBPACK FOOTER //
// src/pages/cleaner/inventory/index.vue